'use client';

import Script from 'next/script';
import { useEffect } from 'react';

const isYandexEnabled = process.env.NEXT_PUBLIC_ENABLE_YANDEX_METRICA === 'true';
const yandexCounterId = Number(process.env.NEXT_PUBLIC_YANDEX_METRICA_ID || 0);

export default function YandexMetrika() {
  useEffect(() => {
    if (!isYandexEnabled || !yandexCounterId || typeof window === 'undefined') {
      return;
    }

    const win = window as Window & {
      ym?: ((...args: unknown[]) => void) & { a?: unknown[][]; l?: number };
    };

    if (typeof win.ym !== 'function') {
      win.ym = function(...args: unknown[]) {
        (win.ym!.a = win.ym!.a || []).push(args);
      } as typeof win.ym;
    }

    win.ym!.l = Date.now();

    win.ym!(yandexCounterId, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      ecommerce: 'dataLayer',
      trackHash: true,
    });

    const handleRouteChange = (url: string) => {
      win.ym!(yandexCounterId, 'hit', url);
    };

    const onHashChange = () => handleRouteChange(window.location.href);
    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  if (!isYandexEnabled || !yandexCounterId) {
    return null;
  }

  return (
    <>
      <Script
        id="yandex-metrica"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(m,e,t,r,i,k,a){
              m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) return;
              }
              k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
          `,
        }}
      />
      <noscript>
        <div>
          <img
            src={`https://mc.yandex.ru/watch/${yandexCounterId}`}
            style={{ position: 'absolute', left: '-9999px' }}
            alt=""
          />
        </div>
      </noscript>
    </>
  );
}